export enum UploadTypeEnum {
  Video = 'Video',
  Document = 'Document',
  Image = 'Image',
}

export const allUploadTypes = Object.keys(UploadTypeEnum);
